import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { Connection1cFindInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-find.dto';
import type { Connection1cFlatListQueryInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-flat-list-query.dto';
import type { Connection1cPageInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-page.dto';
import type { Connection1cRegistryQueryInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-registry-query.dto';
import type { Connection1cCredentialsInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-credentials.dto';
import type { Connection1cCredentialsTestResultInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-credentials-test-result.dto';
import type { Connection1cConsoleFormInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c-console/connection-1c-console-form.dto';
import type { Connection1cConsoleResultInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c-console/connection-1c-console-result.dto';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Integration1cService extends BaseService {
  protected baseUrl = '/basis/client/erp-1c/connection';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: Connection1cRegistryQueryInterface): Observable<Connection1cPageInterface> {
    return this.http.get<Connection1cPageInterface>(`${this.baseUrl}/items`, {
      params: queryParams ? this.objectToHttpParams(queryParams as Record<string, unknown>) : {}
    });
  }

  public findManyFlat(params?: Connection1cFlatListQueryInterface): Observable<Connection1cFindInterface[]> {
    return this.http.get<Connection1cFindInterface[]>(`${this.baseUrl}/flat`, {
      params: params ? this.objectToHttpParams(params as Record<string, unknown>) : {}
    });
  }

  public override find<T = Connection1cFindInterface>(query?: Connection1cFlatListQueryInterface): Observable<T[]> {
    return this.findManyFlat(query) as Observable<T[]>;
  }

  public testConnection(database: Connection1cCredentialsInterface): Observable<Connection1cCredentialsTestResultInterface> {
    return this.http.post<Connection1cCredentialsTestResultInterface>(`${this.baseUrl}/test`, database);
  }

  public getAvailableMethods(id: number): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/${id}/available-methods`);
  }

  public testConsoleExecute(id: number, body: Connection1cConsoleFormInterface): Observable<Connection1cConsoleResultInterface> {
    return this.http.post<Connection1cConsoleResultInterface>(`${this.baseUrl}/${id}/test-console`, body);
  }
}
